import { IMAGE_ENGINE_TIERS, engineLabel } from "@/shared/brand/engineTiers";

/**
 * provider 中文标签(全中文化 Batch 0.5 兜底:未映射 provider 不裸漏英文 key)。
 * 波A:原住在 `ui/components/apply-template/types.ts`,套模板路删除后把还活着的常量
 * 迁到 model 层(消费方:任务详情 / 模板库卡 / 筛选条)。
 *
 * ★OEM 0929(C-C):对客一律档位名(极速 / 精绘 / 标准 / 高清 / 旗舰·极速 / 旗舰·精修 / 创意),
 * 单一来源在 `@/shared/brand/engineTiers`。本表只是它的静态别名(不附超管真名);
 * 渲染处优先用 {@link posterProviderLabel}(超管非代客态会附真名)。
 */
export const PROVIDER_LABELS: Readonly<Record<string, string>> = IMAGE_ENGINE_TIERS;

/**
 * 上传素材任务判定(provider="UPLOAD",与 backend PosterImportService 的写值同一契约)。
 * 卡面/详情对它不摆「N/N 成功」那套出图计数 —— 它压根没出过图。
 */
export function isUploadProvider(provider: string | null | undefined): boolean {
  return provider === "UPLOAD";
}

/**
 * OPENAI 家族判据(0925 收尾波 B5):蒙版局部重绘只有万相实现,选中 OPENAI 系任一子渠道
 * (普通档 / VIP / 2.5 Flare / Sunburst,见上面 PROVIDER_LABELS 的枚举与注释)都要拦。
 * 按前缀判定而不逐个列举字面量 —— 以后再上新的 OPENAI_* 档位不用回来改这条判据。
 */
export function isOpenAiFamilyProvider(provider: string | null | undefined): boolean {
  return !!provider && provider.startsWith("OPENAI");
}

export function posterProviderLabel(provider: string | null | undefined): string {
  return engineLabel("image", provider);
}
